import React from 'react';
import { theme } from 'antd';

interface ArrowsLeftRightIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const { useToken } = theme;

const ArrowsLeftRightIcon: React.FC<ArrowsLeftRightIconProps> = ({
  width = 18,
  height = 18,
  className = '',
  color,
  style = {},
}) => {
  const { token } = useToken();
  const iconColor = color || token.colorPrimary;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g id="ArrowsLeftRight">
        <path
          id="Vector"
          d="M15.0229 12.773L12.7729 15.023C12.6674 15.1286 12.5242 15.1879 12.375 15.1879C12.2257 15.1879 12.0825 15.1286 11.977 15.023C11.8714 14.9175 11.8121 14.7743 11.8121 14.6251C11.8121 14.4758 11.8714 14.3326 11.977 14.2271L13.2672 12.9376H3.37495C3.22577 12.9376 3.0827 12.8783 2.97721 12.7728C2.87172 12.6673 2.81245 12.5243 2.81245 12.3751C2.81245 12.2259 2.87172 12.0828 2.97721 11.9773C3.0827 11.8718 3.22577 11.8126 3.37495 11.8126H13.2672L11.977 10.523C11.8714 10.4175 11.8121 10.2743 11.8121 10.1251C11.8121 9.9758 11.8714 9.83265 11.977 9.7271C12.0825 9.62155 12.2257 9.56226 12.375 9.56226C12.5242 9.56226 12.6674 9.62155 12.7729 9.7271L15.0229 11.9771C15.0752 12.0293 15.1167 12.0914 15.145 12.1597C15.1733 12.228 15.1879 12.3011 15.1879 12.3751C15.1879 12.449 15.1733 12.5222 15.145 12.5905C15.1167 12.6588 15.0752 12.7208 15.0229 12.773ZM5.22699 8.27304C5.33253 8.37859 5.47569 8.43788 5.62495 8.43788C5.77422 8.43788 5.91738 8.37859 6.02292 8.27304C6.12847 8.16749 6.18777 8.02434 6.18777 7.87507C6.18777 7.7258 6.12847 7.58265 6.02292 7.4771L4.73269 6.18757H14.625C14.7741 6.18757 14.9172 6.12831 15.0227 6.02282C15.1282 5.91733 15.1875 5.77425 15.1875 5.62507C15.1875 5.47588 15.1282 5.33281 15.0227 5.22732C14.9172 5.12183 14.7741 5.06257 14.625 5.06257H4.73269L6.02292 3.77304C6.12847 3.66749 6.18777 3.52434 6.18777 3.37507C6.18777 3.2258 6.12847 3.08265 6.02292 2.9771C5.91737 2.87155 5.77422 2.81226 5.62495 2.81226C5.47569 2.81226 5.33253 2.87155 5.22699 2.9771L2.97699 5.2271C2.92469 5.27934 2.8832 5.34138 2.85489 5.40966C2.82658 5.47795 2.81201 5.55115 2.81201 5.62507C2.81201 5.69899 2.82658 5.77219 2.85489 5.84047C2.8832 5.90876 2.92469 5.9708 2.97699 6.02304L5.22699 8.27304Z"
          fill={iconColor}
        />
      </g>
    </svg>
  );
};

export default ArrowsLeftRightIcon;
